import getAttachmentWellInitialValue from './getAttachmentWellInitialValue';
import initializeAttachments from '../actions/initialization/initializeAttachments';
import type AttachmentWellViewState from '../schema/AttachmentWellViewState';
import type { MailboxInfo } from 'owa-client-ids';
import type AttachmentType from 'owa-service/lib/contract/AttachmentType';
import type ItemId from 'owa-service/lib/contract/ItemId';

export default function getAttachmentWellForCompose(
    composeId: string,
    attachmentsToInitialize?: {
        attachments: AttachmentType[];
        mailboxInfo: MailboxInfo;
        parentItemId: ItemId;
    }
): AttachmentWellViewState {
    const attachmentWellViewState = getAttachmentWellInitialValue(
        false /*isReadOnly*/,
        attachmentsToInitialize === undefined /*isInitialized*/,
        composeId
    );
    if (attachmentsToInitialize) {
        const { attachments, mailboxInfo, parentItemId } = attachmentsToInitialize;
        initializeAttachments(
            attachments,
            mailboxInfo,
            attachmentWellViewState,
            true /* forceUpdateAttachmentsInStore */,
            true /* isInitializationForCompose */,
            null,
            parentItemId
        );
    }
    return attachmentWellViewState;
}
